import Repository from "./Repository";

const GetAllFutureOrders = "GetAllFutureOrders.php";
const GetOrder = "GetOrder.php";
const PostUpdateOrderField = "PostUpdateCCOrderField.php";
const PostUpdateOrder = "PostUpdateCCOrder.php";
const PostCancelOrder = "PostCancelCCOrder.php";
const PostReSendConfirmation = "PostReSendConfirmation.php";
const PostUpdateIdentify = "PostUpdateIdentify.php";


export default {	
	getAllFutureOrders(storeId){
		return Repository.get(`${GetAllFutureOrders}?storeId=${storeId}`);		
	},	
	getOrder(orderRef, pin, lastFour, notifyTel, notifyEmail, identifyType, storeId){
		console.log(notifyTel + "  " + notifyEmail + "  " + identifyType + "  " + storeId)
		return Repository.get(`${GetOrder}?orderRef=${orderRef}&pin=${pin}&lastFour=${lastFour}&notifyTel=${notifyTel}&notifyEmail=${notifyEmail}&identifyType=${identifyType}&storeId=${storeId}`);		
	},	
	postUpdateOrderField(payload){
		return Repository.post(`${PostUpdateOrderField}`, payload);		
	},	
	postUpdateOrder(payload){
		return Repository.post(`${PostUpdateOrder}`, payload);		
	},	
	postCancelOrder(payload){
		return Repository.post(`${PostCancelOrder}`, payload);		
	},	
	postResendConfirmation(payload){
		return Repository.post(`${PostReSendConfirmation}`, payload);		
	},	
	postUpdateIdentify(payload){
		return Repository.post(`${PostUpdateIdentify}`, payload);		
	}
};



